import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
// _mock
// utils
// components
import Iconify from 'src/components/iconify';
import { USER_TYPE_SHOPADMIN, USER_TYPE_SUPER_ADMIN } from 'src/config-global';
//

// ----------------------------------------------------------------------

export default function ProfileHome({ info }) {

  const renderAbout = (
    <Card>
      <CardHeader title="About" />

      <Stack spacing={2} sx={{ p: 3 }}>

        <Stack direction="row" sx={{ typography: 'body2' }}>
          <Iconify icon="fluent:mail-24-filled" width={24} sx={{ mr: 2 }} />
          {info.email}
        </Stack>
        {info && info?.user_type !== USER_TYPE_SUPER_ADMIN  && info?.user_type!==USER_TYPE_SHOPADMIN && <Stack direction="row" spacing={2}>
          <Iconify icon="mage:phone-fill" width={24} />

          <Box sx={{ typography: 'body2' }}>
            <Link variant="subtitle2" color="inherit">
              <span>{info?.phone}</span>
            </Link>
          </Box>
        </Stack>}
      </Stack>
    </Card>
  );



  return (
    <Grid container spacing={3}>
      <Grid xs={12} md={12}>
        <Stack spacing={3}>
          {renderAbout}
        </Stack>
      </Grid>
    </Grid>
  );
}

ProfileHome.propTypes = {
  info: PropTypes.object,
};
